import { AnonymousHeader } from '~/components/Header/AnonymousHeader';
import type { JSX } from 'react';
import { ScreenContainer } from '../../layouts/shared/ScreenContainer';

export const LoadingState = (): JSX.Element => {
  return (
    <>
      <AnonymousHeader />
      <ScreenContainer />
    </>
  );
};
